import { pathsManifest as authCheckPaths } from '@zg-rentals/particles-js-auth';
import HTTP_STATUS from '@common/constants/HttpConstants';
import StringConstants from '@common/constants/StringConstants';

export const GET = 'GET';
export const POST = 'POST';
export const DELETE = 'DELETE';

export const getSignInPage = () => {
  const pathname = window.location.pathname;
  const search = window.location.search || '';
  return authCheckPaths.zillow.signInPage(pathname, search);
};

export const checkStatus = (json) => {
  if (!json.success || json.httpStatus >= HTTP_STATUS.SC_BAD_REQUEST) {
    return Promise.reject(json);
  }
  return json;
};

export const checkRequestActionSuccess = (action: any = {}) => {
  // request actions must not have an error, must have a payload, and must not have a payload error
  if (action.error || (action.payload && action.payload.error)) {
    return Promise.reject({ action });
  }
  return action;
};

export const checkApiAuthorizationStatus = ({ action = {} }: any) => {
  if (action.payload && action.payload.status === HTTP_STATUS.SC_UNAUTHORIZED) {
    window.location = getSignInPage();
    return null;
  }
  return Promise.reject({ action });
};

export const buildLandlordPaymentsUrl = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.API;
  const rentPaymentBase = StringConstants.API.RENT_PAYMENT;
  return proxy + api + rentPaymentBase + path;
};

export const buildLandlordPaymentsUrlV2 = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.API_V2;
  const rentPaymentBase = StringConstants.API.RENT_PAYMENT;
  return proxy + api + rentPaymentBase + path;
};

export const buildLandlordPaymentsUrlV3 = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.API_V3;
  const rentPaymentBase = StringConstants.API.RENT_PAYMENT;
  return proxy + api + rentPaymentBase + path;
};

export const buildRenterPaymentsUrlV2 = (path: string): string => {
  const proxy = StringConstants.API.RENTER_HUB.PROXY;
  const api = StringConstants.API.RENTER_HUB.API_V2;
  const rentPaymentBase = StringConstants.API.RENT_PAYMENT;
  return proxy + api + rentPaymentBase + path;
};

export const buildRentCreditReportUrl = (path: string): string => {
  const proxy = StringConstants.API.RENTER_HUB.PROXY;
  const api = StringConstants.API.RENTER_HUB.API;
  const rentCreditReportBase = StringConstants.API.RENT_CREDIT_REPORT;
  return proxy + api + rentCreditReportBase + path;
};

export const buildRentalProtectionUrl = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.API;
  const rentalProtectionBase = StringConstants.API.RENTAL_PROTECTION;
  return proxy + api + rentalProtectionBase + path;
};

export const buildUserProfileUrl = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.API;
  const userProfileBase = StringConstants.API.USER_PROFILE;
  return proxy + api + userProfileBase + path;
};

export const buildAddressesUrl = (path: string): string => {
  const proxy = StringConstants.API.RENTAL_MANAGER.PROXY;
  const api = StringConstants.API.RENTAL_MANAGER.PROPERTIES_API;
  const addressesBase = StringConstants.API.ADDRESSES;
  return proxy + api + addressesBase + path;
};
